import { sessionStorage } from 'dibs-browser-storage';

const SESSION_STORAGE_OPTIN_PROMPT = 'isOptinPromptShown';
const SESSION_STORAGE_PDP_ITEM_SAVED = 'pdpItemSaved';

export const getIsOptinPromptShown = (): boolean => {
    return !!sessionStorage.getItem(SESSION_STORAGE_OPTIN_PROMPT);
};

export const setIsOptinPromptShown = (): void => {
    sessionStorage.setItem(SESSION_STORAGE_OPTIN_PROMPT, true);
};

export const getSessionPdpItemSaved = (): boolean => {
    return !!sessionStorage.getItem(SESSION_STORAGE_PDP_ITEM_SAVED);
};

export const setSessionPdpItemSaved = (): void => {
    sessionStorage.setItem(SESSION_STORAGE_PDP_ITEM_SAVED, true);
};
